module.exports = __webpack_public_path__ + "static/img/1.17e6f83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/1.png
// module id = nSBI
// module chunks = 1